import { Box, Flex, Link, Text, VStack } from '@chakra-ui/react';
import { StepTitle } from '../step-title';
import { InfoBox } from '../info-box';

export const ChargedKitStep: React.FC = () => {
  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      minH="100vh"
      px={6}
      pt={16}
      pb={24}
      bg="white"
    >
      <VStack gap={6} maxW="500px" w="full">
        <StepTitle stepNumber={1} title="Fully Charged Kit" />

        <Box
          w="full"
          p={5}
          bg="gray.50"
          borderRadius="xl"
          border="1px solid"
          borderColor="gray.200"
        >
          <VStack align="flex-start" gap={4}>
            <Text fontSize="sm" color="gray.800">
              Your FrogBox camera and encoder should already be fully charged
              providing up to 12 hours of battery life.
            </Text>

            <InfoBox>
              If charging is needed, click the following link for a guide on{' '}
              <Link
                href="https://frogbox.freshdesk.com/support/solutions/articles/51000510474-how-to-charge-your-v2-kit"
                color="green.600"
                fontWeight="semibold"
                textDecoration="underline"
                _hover={{ color: 'green.700' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                how to charge your kit and monitor battery life
              </Link>
              . Allow up to 4 hours for a full charge.
            </InfoBox>
          </VStack>
        </Box>
      </VStack>
    </Flex>
  );
};
